<template>
  <div class="home">
    <!-- 头部 -->
    <div class="iconsTop">
      <img src="../assets/images/img_22.png" alt="" id="icons">
      <div class="explain">
        <span><i>1</i>下载安装</span>
        <span><i>2</i>信任助手</span>
        <span><i>3</i>打开钱大师</span>
      </div>
    </div>
    <!-- 1 -->
    <div class="stepOne">
      <img src="../assets/images/img_23.png" alt="" class="cornerMarker">
      <div class="nums">1</div>
      <div class="oneCenter">
        <div class="onecenterT">下载安装：<span>钱大师</span></div>
        <div @click.stop="downloadHelper" class="btnOne">立即安装</div>
      </div>
    </div>

    <!-- 2 -->
    <div class="stepTwo">
      <img src="../assets/images/img_23.png" alt="" class="cornerMarker">
      <div class="nums">2</div>
      <div class="twoCenter">
        <div class="twoTop">
          <span>小提示:助手正常使用期间请勿卸载,避免造成无法使用！</span>
          <div>安装成功后，点击<span>设置信任 </span></div>
          <div>找到钱大师并信任</div>
        </div>
        <img src="../assets/images/img_78.png" alt="" id="twoImg">
        <div class="setExplain">
          <div>可通过【<span>设置<img src="../assets/images/img_83.png" alt="">通用<img src="../assets/images/img_83.png" alt="">描述文件与设备管理</span>】</div>
          <div>找到相应文件并信任</div>
        </div>
        <div @click="handleTrust" class="btnTwo">设置信任</div>
      </div>
    </div>

    <!-- 3 -->
    <div class="stepThree">
      <img src="../assets/images/img_23.png" alt="" class="cornerMarker">
      <div class="nums">3</div>
      <div class="threeCenter">
        <div class="threeTop">
          <div>成功信任后</div>
          <div>若无法打开，请返回桌面打开钱大师</div>
        </div>
        <div @click="openHelper" class="btnThree">打开钱大师</div>
      </div>
    </div>
  </div>
</template>

<script>
  import clientApi from '../assets/js/clientApi.js';
  import { Dialog } from 'vant';

  export default {
    components: {
      
    },
    data() {
      return {
        downloadUrl:'',
        show: true
      }
    },
    created() {
      this.getBaseInfo();
    },
    mounted() {
      this.init();
    },
    methods: {
      init(){
        //获取助手下载地址
        let datas = {}
        this.$http.GETS('System/systemConfig',datas,(res)=>{
          this.downloadUrl = res.data.plist_url;
        });
        //从助手获取登录需要用的数据
        clientApi.isClientLogin().then((res) => {
          //如果助手登录成功则执行H5端登录
          if(res.data.newlogin === true){
            let datas = {
              home:res.data.home,
              idfa:res.data.idfa,
              type:res.data.type
            }
            //登录成功跳转首页,失败提示失败信息
            this.$http.POSTS('Guide/doLogin',datas,(res)=>{
              const {code,msg} = res 
              if(code!==2000){
                  this.$dialog.alert({
                    message: '-'+msg
                  });
              }
              this.$router.push('/');
            });
          }else{
            //提示用户助手未登录
            this.$dialog.alert({
              message: '钱大师助手登录失败，若存在老版钱大师，请先卸载~'
            });
          }
        }).catch((err) => {
          //提示用户打开或下载app
          this.$dialog.confirm({
            message: '钱大师助手未启动，若存在老版钱大师，请先卸载~',
            confirmButtonText: '打开助手',
            cancelButtonText: '安装助手',
          }).then((res) => {
            location.href = "LongFlower://";
          });
        })  
      },
      // 立即下载
      downloadHelper() {
        if(this.downloadUrl == '') {
          Dialog.alert({
            title: '温馨提示',
            message: '钱大师助手暂时无法安装，我们正在全力修复中，请稍后再试！'
          });
        }else {
          location.href = this.downloadUrl;
        }
      },
      getBaseInfo() {
        this.$http.GETS('System/systemConfig',{},(res)=>{
          localStorage.setItem('webServerDomain', res.data.h5_page_url);
        });
      },
      // 设置信任
      handleTrust() {
        location.href='https://package.cattryapp.com/fksjDev.mobileprovision';
      },
      // 打开应用
      openHelper() {
        location.href = "LongFlower://";
      }
    },
  }
</script>

<style lang="less"  scoped>
  .home{
    padding-bottom: 48px;
    // 头部
    .iconsTop{
      display: flex;
      flex-direction: column;
      align-items: center;
      #icons{
        margin-top: 27px;
        width: 85px;
        height: 26px;
      }
      .explain{
        margin-top: 17px;
        font-size: 14px;
        color: #000000;
        display: flex;
        span{
          margin: 0 6px;
          display: flex;
          i{
            font-style: normal;
            width: 13px;
            height: 13px;
            display: inline-block;
            border: 1px solid #000000;
            font-size: 10px;
            border-radius: 50%;
            margin-right: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    // 角标及数字
    .cornerMarker{
      width: 34px;
      height: 31px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .nums{
      font-size: 14px;
      color: #FFFFFF;
      position: absolute;
      top: 4px;
      left: 11px;
    }

    // 1
    .stepOne{
      width: 336px;
      height: 116px;
      margin: 14px auto 12px;
      background: #FFFFFF;
      border-radius: 8px;
      position: relative;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .1);
      .oneCenter{
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        .onecenterT{
          margin-top: 20px;
          color: #333333;
          font-size: 14px;
          span{
            font-weight: bold;
          }
        }
        .btnOne{
          margin-bottom: 20px;
          width: 260px;
          height: 40px;
          background: #E50113;
          border-radius: 19px;
          color: #FFFFFF;
          font-size: 16px;
          text-align: center;
          line-height: 40px;
        }
      }
    }

    // 2
    .stepTwo{
      width: 336px;
      height: 376px;
      margin: 0 auto 12px;
      background: #FFFFFF;
      border-radius: 8px;
      position: relative;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .1);
      .twoCenter{
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        .twoTop{
          font-size: 14px;
          text-align: center;
          margin-top: 20px;
          div{
            margin: 2px 0;
            span{
              font-weight: bold;
              margin-left: 6px;
            }
          }
        }
        #twoImg{
          width: 202px;
          height: 180px;
        }
        .setExplain{
          font-size: 14px;
          color: #666666;
          div{
            margin: 2px 0;
            text-align: center;
            span{
              color: #4A90E2;
              img{
                width: 5px;
                height: 8px;
                margin: 0 3px;
              }
            }
          }
        }
        .btnTwo{
          width: 260px;
          height: 40px;
          background: #E50113;
          font-size: 16px;
          color: #FFFFFF;
          text-align: center;
          line-height: 40px;
          border-radius: 24px;
          margin-bottom: 20px;
        }
      }
    }

    // 3
    .stepThree{
      width: 336px;
      height: 140px;
      margin: 0 auto;
      background: #FFFFFF;
      border-radius: 8px;
      position: relative;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .1);
      .threeCenter{
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        .threeTop{
          margin-top: 20px;
          div{
            margin: 2px 0;
            text-align: center;
            font-size: 14px;
            color: #666666;
            &:first-of-type{
              color: #333333;
            }
          }
        }
        .btnThree{
          margin-bottom: 20px;
          width: 260px;
          height: 40px;
          background: #E50113;
          border-radius: 19px;
          color: #FFFFFF;
          font-size: 16px;
          text-align: center;
          line-height: 40px;
        }
      }
    }
    
  }
</style>

